<agr-page-tabs>
  <div class="wrapper--spacing-horizontal spacing--margin-bottom">
    <h1 class="text--h1">{{ 'height-measurement.title' | translate }}</h1>
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="spacing--margin-bottom--large">
      <a
        mat-tab-link
        [routerLink]="'/measurements'"
        routerLinkActive
        #measurement="routerLinkActive"
        [active]="measurement.isActive"
      >
        {{ 'height-measurement.measurement-title' | translate }}
      </a>
      <a
        mat-tab-link
        [routerLink]="'/overview'"
        routerLinkActive
        #other="routerLinkActive"
        [active]="other.isActive"
      >
        {{ 'height-measurement.overview-title' | translate }}
      </a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <div class="wrapper--spacing-vertical">
        <router-outlet></router-outlet>
      </div>
    </mat-tab-nav-panel>
  </div>
</agr-page-tabs>
